import { sqliteTable, text, integer, uniqueIndex } from "drizzle-orm/sqlite-core";
import { aiAgents } from "./ai-agents";

// ============================================================================
// ai_agent_tools — Which tools each agent can use
// ============================================================================
export const aiAgentTools = sqliteTable(
  "ai_agent_tools",
  {
    id: text("id").primaryKey(), // ULID
    agentId: text("agent_id")
      .notNull()
      .references(() => aiAgents.id),
    toolName: text("tool_name").notNull(), // e.g. "car_rental_check_availability"
    isEnabled: integer("is_enabled").default(1),
    // Audit fields
    createdAt: text("created_at").notNull(),
    createdBy: text("created_by"),
  },
  (table) => [
    uniqueIndex("idx_agent_tools_unique").on(table.agentId, table.toolName),
  ]
);

export type AiAgentTool = typeof aiAgentTools.$inferSelect;
export type NewAiAgentTool = typeof aiAgentTools.$inferInsert;
